import actionTypes from './actionTypes';
import { RUN_ERROR_KINDS } from './constants';
import type { OptionListKey } from './constants';
import type {
  IFetchOptionsErrorPayload,
  IFetchOptionsRequestPayload,
  IFetchOptionsSuccessPayload,
  IRunError,
  IFormData,
  IRateSimulatorResult,
  IRunPayload,
} from './types';

const actions = {
  fetchOptionsRequest: (payload: IFetchOptionsRequestPayload) => ({
    type: actionTypes.FETCH_OPTIONS_REQUEST,
    payload,
  }),

  fetchOptionsSuccess: (payload: IFetchOptionsSuccessPayload) => ({
    type: actionTypes.FETCH_OPTIONS_SUCCESS,
    payload,
  }),

  fetchOptionsError: (payload: IFetchOptionsErrorPayload) => ({
    type: actionTypes.FETCH_OPTIONS_ERROR,
    payload,
  }),

  // Empties one list, so the options answering a pick just left are never offered under its
  // replacement.
  clearListOptions: (payload: OptionListKey) => ({
    type: actionTypes.CLEAR_LIST_OPTIONS,
    payload,
  }),

  fetchFormDataRequest: () => ({
    type: actionTypes.FETCH_FORM_DATA_REQUEST,
  }),

  fetchFormDataSuccess: (payload: IFormData) => ({
    type: actionTypes.FETCH_FORM_DATA_SUCCESS,
    payload,
  }),

  fetchFormDataError: () => ({
    type: actionTypes.FETCH_FORM_DATA_ERROR,
  }),

  runRequest: (payload: IRunPayload) => ({
    type: actionTypes.RUN_REQUEST,
    payload,
  }),

  runSuccess: (payload: IRateSimulatorResult) => ({
    type: actionTypes.RUN_SUCCESS,
    payload,
  }),

  runError: (payload: IRunError = { kind: RUN_ERROR_KINDS.UNKNOWN }) => ({
    type: actionTypes.RUN_ERROR,
    payload,
  }),

  markResultStale: () => ({
    type: actionTypes.MARK_RESULT_STALE,
  }),

  clearStore: () => ({
    type: actionTypes.CLEAR_STORE,
  }),
};

export default actions;
